import {createTheme} from "@mui/material";
import {themeOptions} from "./themeOptions";

export const getTheme = (revDir: boolean) => createTheme({
    ...themeOptions,

    direction: revDir
        ? 'rtl'
        : 'ltr',
})